import '../css/style.css';
import { Game } from './components/Game';

// Create how to play section


let game; // Game instance reference
let animationFrameId; // Store animation frame ID

document.addEventListener('DOMContentLoaded', () => {
  console.log('Football Vibes game initialized');
  
  // Create the game
  game = new Game();
  
  // Check if we're coming from the portal
  const urlParams = new URLSearchParams(window.location.search);
  const isFromPortal = urlParams.get('portal') === 'true';
  
  // Always initialize the game directly
  game.init();
  
  // CRITICAL: Always start the animation loop regardless of portal status
  // This ensures the game can run properly in all scenarios
  function animate() {
    animationFrameId = requestAnimationFrame(animate);
    if (game) {
      game.update();
    }
  }
  
  // Start animation loop immediately
  animate();
  console.log('Animation loop started');
  
  // Handle window/tab closing
  window.addEventListener('beforeunload', () => {
    if (game) {
      game.cleanup();
    }
    
    // Cancel animation frame if it exists
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }
  });
}); 